import { Pencil } from "lucide-react";
import { buildStrapiPageEditUrl } from "@/features/content/lib/strapi-page-url";
import type { ContentEntry } from "@/types/content";

interface ContentEditButtonProps {
  entry: ContentEntry;
}

export function ContentEditButton({ entry }: ContentEditButtonProps) {
  const id = String(entry.id);
  const locale = typeof entry.locale === "string" ? entry.locale : undefined;
  const label = entry.title ?? "المحتوى";
  const href = buildStrapiPageEditUrl(id, locale);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center text-muted-foreground transition-colors hover:text-primary"
      aria-label={`تعديل ${label} في نظام إدارة المحتوى`}
      title="تعديل"
    >
      <Pencil className="h-4 w-4" />
    </a>
  );
}
